import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const contentApiService = createApi({
  reducerPath: "contentApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getContent: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `content/get-content${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetContentQuery } = contentApiService;
